import UserTable from "./user-table";

export default UserTable;
